import { useState } from 'react'
import { useEditorStore } from '../../store/editor.store'

const FREE_PAGE_LIMIT = 3

export function PagesPanel() {
  const { pages, activePageId, addPage, deletePage, setActivePage, renamePage, duplicatePage } =
    useEditorStore()
  const userPlan = useEditorStore((s) => s.userPlan)
  const [editingId, setEditingId] = useState<string | null>(null)
  const [editingValue, setEditingValue] = useState('')
  const [confirmDeleteId, setConfirmDeleteId] = useState<string | null>(null)

  function startRename(id: string, currentTitle: string) {
    setEditingId(id)
    setEditingValue(currentTitle)
  }

  function commitRename() {
    if (editingId && editingValue.trim()) {
      renamePage(editingId, editingValue.trim())
    }
    setEditingId(null)
  }

  function handleDeleteClick(id: string) {
    if (confirmDeleteId === id) {
      deletePage(id)
      setConfirmDeleteId(null)
    } else {
      setConfirmDeleteId(id)
      setTimeout(() => setConfirmDeleteId(null), 2500)
    }
  }

  const totalBlocks = pages.reduce(
    (sum, p) => sum + p.sections.reduce((s, sec) => s + sec.blocks.length, 0),
    0,
  )

  return (
    <div className="pages-panel">
      <div className="pages-panel-header">
        <span className="pages-panel-title">Страницы</span>
        <span className="pages-panel-meta">{pages.length} стр · {totalBlocks} блоков</span>
      </div>

      <div className="pages-list">
        {pages.map((page) => {
          const blockCount = page.sections.reduce((s, sec) => s + sec.blocks.length, 0)
          const isActive = page.id === activePageId
          const isEditing = editingId === page.id
          const isConfirmDelete = confirmDeleteId === page.id

          return (
            <div
              key={page.id}
              className={`page-item ${isActive ? 'active' : ''}`}
              onClick={() => !isEditing && setActivePage(page.id)}
            >
              <div className="page-item-icon">
                <span style={{ fontSize: '14px' }}>📄</span>
              </div>
              <div className="page-item-body">
                {isEditing ? (
                  <input
                    autoFocus
                    className="page-item-rename-input"
                    value={editingValue}
                    onChange={(e) => setEditingValue(e.target.value)}
                    onBlur={commitRename}
                    onKeyDown={(e) => {
                      if (e.key === 'Enter') commitRename()
                      if (e.key === 'Escape') setEditingId(null)
                      e.stopPropagation()
                    }}
                    onClick={(e) => e.stopPropagation()}
                  />
                ) : (
                  <div className="page-item-title" onDoubleClick={() => startRename(page.id, page.title)}>
                    {page.title}
                  </div>
                )}
                <div className="page-item-meta">
                  <span className="page-item-slug">{page.slug || '/'}</span>
                  <span className="page-item-count">{blockCount} блоков</span>
                </div>
              </div>
              <div className="page-item-actions" onClick={(e) => e.stopPropagation()}>
                <button
                  className="page-action-btn"
                  title="Дублировать страницу"
                  onClick={() => duplicatePage(page.id)}
                >⎘</button>
                <button
                  className="page-action-btn"
                  title="Переименовать"
                  onClick={() => startRename(page.id, page.title)}
                >✏</button>
                {pages.length > 1 && (
                  <button
                    className={`page-action-btn page-action-delete ${isConfirmDelete ? 'confirm' : ''}`}
                    title={isConfirmDelete ? 'Нажмите ещё раз для подтверждения' : 'Удалить страницу'}
                    onClick={() => handleDeleteClick(page.id)}
                  >
                    {isConfirmDelete ? '?' : '✕'}
                  </button>
                )}
              </div>
            </div>
          )
        })}
      </div>

      {userPlan === 'FREE' && pages.length >= FREE_PAGE_LIMIT && (
        <div style={{ margin: '8px 12px', padding: '10px 12px', background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: '8px', fontSize: '12px', color: '#92400e', lineHeight: 1.5 }}>
          Лимит FREE плана: {FREE_PAGE_LIMIT} страницы. <a href="/dashboard" style={{ color: '#f97316', fontWeight: 600 }}>Перейти на Personal →</a>
        </div>
      )}
      <button
        className="pages-add-btn"
        disabled={userPlan === 'FREE' && pages.length >= FREE_PAGE_LIMIT}
        onClick={() => addPage()}
        style={userPlan === 'FREE' && pages.length >= FREE_PAGE_LIMIT ? { opacity: 0.4, cursor: 'not-allowed' } : undefined}
      >
        <span>+</span> Добавить страницу
      </button>
    </div>
  )
}
